module.exports = __webpack_public_path__ + "static/img/el-icon-my-shopping.ae2a887.png";